/**
 * @generated SignedSource<<93d758450622969b0f7f2ea4ccdf0725>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SudoTriggerClientUpdate_sudo$data = {
  readonly id: string;
  readonly chromeAppUpdateTimes: {
    readonly idleTime: any | null;
    readonly forceTime: any | null;
  } | null;
  readonly " $fragmentType": "SudoTriggerClientUpdate_sudo";
};
export type SudoTriggerClientUpdate_sudo$key = {
  readonly " $data"?: SudoTriggerClientUpdate_sudo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SudoTriggerClientUpdate_sudo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SudoTriggerClientUpdate_sudo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChromeAppUpdateTimes",
      "kind": "LinkedField",
      "name": "chromeAppUpdateTimes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "idleTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forceTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Sudo",
  "abstractKey": null
};

(node as any).hash = "b672e5595fcc2b4614923a44b26457d0";

export default node;
